module.exports = __webpack_public_path__ + "static/ro-workshops-4-ed4fc28d05d4af31a87a14ea766526ea.jpg";